export { default as angleDown } from './angleDown'
export { default as angleLeftB } from './angleLeftB'
export { default as angleRight } from './angleRight'
export { default as angleRightB } from './angleRightB'
export { default as arrowCircleLeft } from './arrowCircleLeft'
export { default as arrowLeft } from './arrow-left'
export { default as at } from './at.svg'
export { default as award } from './award.svg'
export { default as bill } from './bill.svg'
export { default as book } from './book.svg'
export { default as books } from './books.svg'
export { default as building } from './building.svg'
export { default as calendar } from './calendar-alt.svg'
export { default as chatBubbleUser } from './chatBubbleUser'
export { default as check } from './check'
export { default as clock } from './clock-three.svg'
export { default as codeBranch } from './codeBranch'
export { default as coins } from './coins.svg'
export { default as copy } from './copy.svg'
export { default as dropdown } from './corner-right-down.svg'
export { default as delete } from './delete'
export { default as dollar } from './dollar-alt.svg'
export { default as downloadAlt } from './downloadAlt'
export { default as draggableDots } from './draggabledots.svg'
export { default as edit } from './edit-alt.svg'
export { default as envelopeAlt } from './envelopeAlt'
export { default as externalLink } from './external-link-alt.svg'
export { default as eye } from './eye.svg'
export { default as eyeSlash } from './eye-slash.svg'
export { default as ellipsisVertical } from './ellipsis-v.svg'
export { default as facebook } from './facebook.svg'
export { default as file } from './file-alt.svg'
export { default as fileEdit } from './file-edit-alt.svg'
export { default as focusAdd } from './focus-add.svg'
export { default as gift } from './gift.svg'
export { default as globe } from './globe.svg'
export { default as graduation } from './graduation-cap.svg'
export { default as hashtag } from './hashtag.svg'
export { default as history } from './history'
export { default as hourglass } from './hourglass.svg'
export { default as institution } from './university.svg'
export { default as image } from './image.svg'
export { default as label } from './label'
export { default as language } from './language.svg'
export { default as lineChart } from './chart-line.svg'
export { default as link } from './link-h'
export { default as linkedin } from './linkedin.svg'
export { default as location } from './location-point.svg'
export { default as mobile } from './mobile-android.svg'
export { default as network } from './network.svg'
export { default as notebook } from './diary.svg'
export { default as optionsHorizontal } from './optionsHorizontal'
export { default as page } from './file.svg'
export { default as paperclip } from './paperclip.svg'
export { default as people } from './users-alt.svg'
export { default as person } from './user.svg'
export { default as pieChart } from './chart-pie-alt.svg'
export { default as pin } from './pin-filled.svg'
export { default as phone } from './phone.svg'
export { default as print } from './print'
export { default as receipt } from './bill.svg'
export { default as redo } from './redo'
export { default as sortDown } from './sort-amount-down.svg'
export { default as sortUp } from './sort-amount-up.svg'
export { default as sorting } from './sorting'
export { default as slidersVerticalAlt } from './sliders-v-alt.svg'
export { default as spam } from './spam'
export { default as snooze } from './snooze'
export { default as star } from './star'
export { default as search } from './search.svg'
export { default as starSelected } from './starSelected'
export { default as stopwatch } from './stopwatch.svg'
export { default as tag } from './tag'
export { default as times } from './times.svg'
export { default as trash } from './trash-alt.svg'
export { default as usersAlt } from './users-alt.svg'
export { default as calendarAlt } from './calendar-alt'
export { default as twitter } from './twitter.svg'
export { default as window } from './window.svg'
export { default as windows } from './browser.svg'
export { default as minus } from './minus'
export { default as robot } from './robot.svg'
export { default as sync } from './sync'
